// extracted by mini-css-extract-plugin
export default {"updateProfileLink":"styles_updateProfileLink__uETAq","curve":"styles_curve__p23Ri"};